import React from 'react'
import { SettingsSectionV2 } from './SettingsSectionV2'

/*
 * System → Integrations → Sentiment analysis: SENTIMENT_ANALYSYS_API_URL and
 * _KEY, the service behind the Sentiment analysis search (dashboard and API).
 * The key is a secret: admin_audit keeps only its last four characters.
 */
const GROUPS = [
  { key: 'sentiment', title: 'Sentiment analysis service', sub: 'Used by the Sentiment analysis search' },
]

export function SentimentSettingsV2() {
  return (
    <SettingsSectionV2
      title="Sentiment analysis"
      intro="The service the Sentiment analysis search sends its text to. A value saved here replaces the ConfigMap one and works without a restart."
      groups={GROUPS}
      saveNote={() => 'Used from the next Sentiment analysis search.'}
    />
  )
}
